// extracted by mini-css-extract-plugin
export default {"mid-box":"MembershipComplete_mid-box__L3y6g","top":"MembershipComplete_top__-NEjq","mid":"MembershipComplete_mid__J82aD","botm":"MembershipComplete_botm__oCm14"};